module.exports = __webpack_public_path__ + "img/ma2.f63b899c.png";